export type ReasonOption = {
  code: string;
  label: string;
};

export type QualifiedReasonCategory = 'infertility_issue' | 'gynic_issues';

export const CONTACTED_REASONS: ReasonOption[] = [
  { code: 'did_not_pick', label: 'Did not pick' },
  { code: 'busy_in_another_call', label: 'Busy in another call' },
  { code: 'user_disconnected', label: 'User disconnected the call' },
  { code: 'switch_off', label: 'Switched off' },
  { code: 'out_of_coverage', label: 'Out of coverage area / Network issue' },
  { code: 'call_not_connected', label: 'Call not connected / cannot be completed' },
  { code: 'other_reason', label: 'Other reason' },
  { code: 'incorrect_invalid_number', label: 'Incorrect / Invalid number' },
  { code: 'incoming_calls_not_available', label: 'Incoming calls not available' },
  {
    code: 'number_not_in_use',
    label: 'Number not in use / does not exists / out of service',
  },
];

export { LOST_REASONS, REJECTED_REASONS } from '../../../shared/disposition-reasons';

export const QUALIFIED_REASON_CATEGORIES: { code: QualifiedReasonCategory; label: string }[] = [
  { code: 'infertility_issue', label: 'Infertility Issue' },
  { code: 'gynic_issues', label: 'Gynic Issues' },
];

export const QUALIFIED_INFERTILITY_REASONS: ReasonOption[] = [
  { code: 'out_of_state', label: 'Out of state' },
  { code: 'treatment_at_other_hospital', label: 'Treatment at other hospital' },
  { code: 'financial_issue', label: 'Financial issue' },
  { code: 'location_issue', label: 'Location issue' },
  { code: 'on_behalf_of_family_and_friends', label: 'On behalf of family and friends' },
  { code: 'interested_but_in_some_time', label: 'Interested but in some time' },
  { code: 'will_discouse_and_inform_later', label: 'Will discouse and inform later' },
  { code: 'want_boy', label: 'Want boy' },
  { code: 'other_reason', label: 'Other reason' },
];

export const QUALIFIED_REASON_OPTIONS_BY_CATEGORY: Record<QualifiedReasonCategory, ReasonOption[]> = {
  infertility_issue: QUALIFIED_INFERTILITY_REASONS,
  gynic_issues: [],
};

export function getReasonLabel(options: ReasonOption[], code: string) {
  return options.find((option) => option.code === code)?.label ?? code;
}
